<script lang="ts">
import { ref, onMounted, onBeforeUnmount, watch } from "vue";

import { store } from "~/store";
import NavBreadcrumb from "@/components/navigation/NavBreadcrumb.vue";
import NavMenuVertical from "@/components/navigation/NavMenuVertical.vue";
import eventBus from "@/event-bus";
import type { BreadCrumb } from "@/interfaces/BreadCrumb";
import type { BrandImage } from "@/interfaces/BrandImage";
import seoService from "@/services/SeoService";

export default {
  components: {
    NavBreadcrumb,
    NavMenuVertical,
  },
  setup() {
    definePageMeta({
      pageTransition: {
        name: "fade",
        mode: "out-in",
      },
    });

    seoService.setData({
      title: "Mi Perfil",
      noIndex: true,
    });

    const breadcrumbs = ref<BreadCrumb[]>([]);
    const brands = ref<BrandImage[]>([]);
    const breadcrumb2 = ref<BreadCrumb | null>(null);
    const isLargeScreen = ref(false);
    const route = useRoute();

    const updateScreenSize = () => {
      isLargeScreen.value = window.innerWidth >= 1200;
    };

    const getBreadcrumbs = () => {
      let activeBreadcrumbOrder = localStorage.getItem("activeBreadcrumbOrder");
      let activeBreadcrumbLocal;

      if (activeBreadcrumbOrder) {
        activeBreadcrumbLocal = JSON.parse(activeBreadcrumbOrder);
      }
      const baseBreadcrumbs = isLargeScreen.value
        ? [
            { name: "Inicio", to: "/" },
            { name: "Navegación", to: "/perfil" },
            {
              name: activeBreadcrumbLocal?.name,
              to: activeBreadcrumbLocal?.to,
            },
          ]
        : [
            { name: "Mi cuenta", to: "/perfil" },
            {
              name: activeBreadcrumbLocal?.name,
              to: "/perfil/" + activeBreadcrumbLocal?.to,
            },
          ];

      breadcrumbs.value = baseBreadcrumbs;
    };

    onMounted(() => {
      getBreadcrumbs();

      store.commit("setCanCloseMenu", true);
      updateScreenSize();
      window.addEventListener("resize", updateScreenSize);

      eventBus.on("show-breadcrumb", (breadcrumb) => {
        breadcrumb2.value = breadcrumb as BreadCrumb;
        getBreadcrumbs();
      });

      eventBus.on("random-brands-profile", (randomBrands) => {
        brands.value = randomBrands as BrandImage[];
      });
    });

    onBeforeUnmount(() => {
      eventBus.off("show-breadcrumb");
      eventBus.off("random-brands-profile");
      window.removeEventListener("resize", updateScreenSize);
    });

    watch(() => route.path, getBreadcrumbs);

    return {
      breadcrumbs,
      brands,
      isLargeScreen,
    };
  },
};
</script>
<template>
  <div class="container-fluid">
    <div v-if="$route.path !== '/perfil'" class="container-breadcrumb-profile">
      <nav-breadcrumb
        :breadcrumb-data="breadcrumbs"
        :brands="brands"
        :breadcrumb-border="isLargeScreen"
        :chevron="false"
        :semi-bold="true"
        :breadcrumb-small="!isLargeScreen ? 'fs-8' : ''"
      />
    </div>
    <nav-menu-vertical class="mt-2" :is-large-screen="isLargeScreen">
      <NuxtPage> </NuxtPage>
    </nav-menu-vertical>
  </div>
</template>

<style lang="scss">
@use "@/scss/profile";
</style>

<style scoped>
.v-enter-active {
  transition: opacity 0.5s ease;
}

.v-enter-from {
  opacity: 0;
}

@media print {
  body .container-breadcrumb-profile {
    display: none;
  }
}
</style>
